export default __webpack_public_path__ + "static/media/aperto-mao.2aac0703.png";